import React from 'react';
import clsx from 'clsx';
import { PageTabItem } from './PageTabItem/index.ts';
import styles from './PageTabs.module.scss';
export const PageTabs = ({ activeTabId, tabs, onTabChange, direction, hideText = direction == 'horizontal' })=>/*#__PURE__*/ React.createElement("div", {
        className: clsx(styles.pageTabsContainer, styles[direction], 'm-no-drag')
    }, tabs.map((tab)=>/*#__PURE__*/ React.createElement(PageTabItem, {
            key: tab.id,
            tab: tab,
            isActive: activeTabId === tab.id,
            isDisabled: !!tab.disabled,
            onClick: ()=>onTabChange(tab.id),
            hideText: hideText
        })));
